import React from 'react'
import { NavLink } from 'react-router-dom'
const privacypolicy = () => {
  return (
    <div className='bg-slate-900'>
<div className="min-h-screen bg-slate-950 text-white p-8 animate-pop">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        At Tech Studios, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website <a href="https://www.techstudios.co.in/" className="text-blue-400 hover:underline">https://www.techstudios.co.in/</a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">1. Information We Collect</h2>
      <p className="mb-2">
        <strong>Personal Information:</strong> When you interact with our website, we may collect personal details such as your name, email address, phone number, and other contact details that you voluntarily provide when filling out forms, subscribing to newsletters, or contacting us for support.
      </p>
      <p className="mb-2">
        <strong>Non-Personal Information:</strong> We may automatically collect certain non-personal information, including your IP address, browser type, operating system, device type, and browsing behavior on our website. This data helps us improve our services and enhance user experience.
      </p>
      <p className="mb-2">
        <strong>Cookies and Tracking Technologies:</strong> Our website uses cookies and similar tracking technologies to enhance your experience, analyze website traffic, and personalize content. You can choose to disable cookies through your browser settings, though this may impact certain functionalities of the site.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">2. How We Use Your Information</h2>
      <p className="mb-2">We use the collected data for the following purposes:</p>
      <ul className="list-disc list-inside mb-4">
        <li>To Provide and Improve Services: Your information helps us offer personalized services, enhance website functionality, and optimize user experience.</li>
        <li>To Communicate with You: We may use your contact details to respond to inquiries, provide customer support, send promotional materials, or update you about changes to our policies and services.</li>
        <li>To Analyze Website Performance: We use analytical tools to assess website traffic, identify trends, and improve overall site performance.</li>
        <li>To Ensure Security and Prevent Fraud: We may use data to detect, investigate, and prevent fraudulent or unauthorized activities.</li>
        <li>To Comply with Legal Requirements: Your data may be used to fulfill legal obligations, enforce our policies, and cooperate with law enforcement when necessary.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">3. Data Protection and Security</h2>
      <p className="mb-4">
        We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please note that no method of data transmission over the internet is entirely secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">4. Third-Party Services and Data Sharing</h2>
      <p className="mb-2">
        <strong>Third-Party Service Providers:</strong> We may share your information with trusted third-party service providers for tasks such as website analytics, payment processing, marketing, and customer support. These providers are required to maintain the confidentiality and security of your information.
      </p>
      <p className="mb-2">
        <strong>Legal Compliance and Law Enforcement:</strong> We may disclose your personal information if required by law or to protect our rights, comply with legal processes, or respond to government requests.
      </p>
      <p className="mb-2">
        <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of our assets, your personal data may be transferred as part of the transaction.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">5. Your Rights and Choices</h2>
      <p className="mb-2">You have the following rights:</p>
      <ul className="list-disc list-inside mb-4">
        <li><strong>Access and Correction:</strong> You have the right to access, update, or correct your personal information by contacting us at [insert contact email].</li>
        <li><strong>Opt-Out Options:</strong> You can unsubscribe from marketing emails at any time by clicking the "unsubscribe" link in our emails or contacting us directly.</li>
        <li><strong>Data Deletion:</strong> If you wish to have your personal data removed from our records, you may request deletion by reaching out to us.</li>
        <li><strong>Cookie Preferences:</strong> You can manage or disable cookies through your browser settings.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">6. Data Retention</h2>
      <p className="mb-4">
        We retain your personal data for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements. Once the retention period expires, your information will be securely deleted or anonymized.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">7. Children’s Privacy</h2>
      <p className="mb-4">
        Our website is not intended for children under the age of 13. We do not knowingly collect personal data from minors. If we discover that a child under 13 has provided us with personal information, we will take appropriate steps to remove the data.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">8. Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page with an updated effective date. Your continued use of our website after such modifications signifies your acceptance of the revised policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">9. Contact Us</h2>
      <p className="mb-4">
        If you have any questions, concerns, or requests related to this Privacy Policy, please contact us at support@techstudios.co.in.
      </p>
    </div>
    </div>
  )
}

export default privacypolicy